import { formatDisplayDate } from "../types";

type BriefingDateNavigatorProps = {
  previousPublishedDate: string | null;
  nextPublishedDate: string | null;
  currentIssueDate: string;
};

export function BriefingDateNavigator({
  previousPublishedDate,
  nextPublishedDate,
  currentIssueDate,
}: BriefingDateNavigatorProps) {
  return (
    <nav
      aria-label="Briefing date navigation"
      className="flex items-center justify-between gap-4 py-4"
    >
      <div className="flex-1">
        {previousPublishedDate ? (
          <a
            href={`/today?date=${previousPublishedDate}`}
            className="inline-flex items-center gap-2 text-sm font-medium text-neutral-500 dark:text-neutral-400 hover:text-primary dark:hover:text-primary transition-colors"
            aria-label={`Previous edition: ${formatDisplayDate(
              previousPublishedDate,
            )}`}
          >
            <span aria-hidden="true" className="text-lg">
              ←
            </span>
            <span className="hidden sm:inline">
              {formatDisplayDate(previousPublishedDate)}
            </span>
            <span className="sm:hidden">Previous</span>
          </a>
        ) : (
          <span className="text-sm text-neutral-300 dark:text-neutral-700 select-none">
            ← Previous
          </span>
        )}
      </div>

      <div className="text-center">
        <div className="text-base font-bold text-neutral-900 dark:text-white tracking-tight">
          {formatDisplayDate(currentIssueDate)}
        </div>
      </div>

      <div className="flex-1 flex justify-end">
        {nextPublishedDate ? (
          <a
            href={`/today?date=${nextPublishedDate}`}
            className="inline-flex items-center gap-2 text-sm font-medium text-neutral-500 dark:text-neutral-400 hover:text-primary dark:hover:text-primary transition-colors"
            aria-label={`Next edition: ${formatDisplayDate(nextPublishedDate)}`}
          >
            <span className="hidden sm:inline">
              {formatDisplayDate(nextPublishedDate)}
            </span>
            <span className="sm:hidden">Next</span>
            <span aria-hidden="true" className="text-lg">
              →
            </span>
          </a>
        ) : (
          <span className="text-sm text-neutral-300 dark:text-neutral-700 select-none">
            Next →
          </span>
        )}
      </div>
    </nav>
  );
}
